import { Collapse, Divider } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { MobileAppVersionItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useMobileAppVersionContext } from "../../context/MobileAppVersionContext/MobileAppVersionContext";
import { useEffect } from "react";

const AddMobileAppVersion = () => {
	const { addMobileAppVersion, clearMobileAppVersionData, setVersionData, operationStatus } = useMobileAppVersionContext();

	useEffect(() => {
		setVersionData((prevForm) => ({ ...prevForm, forceUpdate: false, appId: 1, platform: "IOS" }));

		return () => {
			clearMobileAppVersionData();
		};
	}, []);

	return (
		<ActionContainer>
			<ActionItemsContainer>
				<h3>Yeni Mobil Uygulama Sürümü Ekleme</h3>
				<Divider />
				<Collapse
					items={MobileAppVersionItems}
					expandIconPosition="end"
					bordered={false}
					ghost
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1", "2"]}
				/>
				<SubmitButtonOverlay>
					<MainButtonComponent onClick={addMobileAppVersion} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Sürümü Ekle
					</MainButtonComponent>
				</SubmitButtonOverlay>
			</ActionItemsContainer>
		</ActionContainer>
	);
};

export default AddMobileAppVersion;
